import BaseApi from '~/api/base';
class ProjectFiles extends BaseApi {
    constructor() {
        super('/project-files');
    }
}
const ProjectFilesApi = new ProjectFiles();
export default ProjectFilesApi;
